export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Object, allSelected, delivery, deliveryAfter, deliveryBefore, deliveryDateSince, deliveryInventory, dueDate, emptyOrderMessage, formatDate, getDriver, isDelivery, map, orders, pickupInventory, renderCreatedDate, renderDeliveryNote, renderDollars, renderName, search, selected, selectedCount, showFilters, showInventory, state, states, today) {
      pug_mixins["options"] = pug_interp = function(available, selected){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate (available)
;(function(){
  var $$obj = (available);
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var v = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var v = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

};


























pug_html = pug_html + "\u003Cform class=\"controls\" autocomplete=\"off\"\u003E";
if (showFilters) {
pug_html = pug_html + "\u003Cdiv class=\"filters overflow-x-auto\"\u003E\u003Cselect class=\"control delivery\" name=\"delivery\"\u003E";
pug_mixins["options"](["Pickup/Delivery", "Delivery", "Pickup"], delivery);
pug_html = pug_html + "\u003C\u002Fselect\u003E";
if (! today) {
pug_html = pug_html + "\u003Cinput" + (" class=\"datefield control due-date\""+" name=\"due-date\" placeholder=\"Due date\""+pug_attr("value", formatDate(dueDate), true, true)+" autocomplete=\"off\"") + "\u003E\u003Cinput" + (" class=\"datefield control delivery-date-since\""+" name=\"delivery-date-since\" placeholder=\"Since\""+pug_attr("value", formatDate(deliveryDateSince), true, true)+" autocomplete=\"off\"") + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"search\"\u003E\u003Cinput" + (" class=\"control search\""+" placeholder=\"Search\" name=\"search\""+pug_attr("value", search, true, true)+" autocomplete=\"off\"") + "\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"actions\"\u003E";
if (showFilters) {
pug_html = pug_html + "\u003Cselect class=\"control states\" name=\"state\"\u003E";
// iterate Object.keys(states)
;(function(){
  var $$obj = Object.keys(states);
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var v = $$obj[pug_index3];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == state), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + " (" + (pug_escape(null == (pug_interp = states[v]) ? "" : pug_interp)) + ")\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var v = $$obj[pug_index3];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == state), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + " (" + (pug_escape(null == (pug_interp = states[v]) ? "" : pug_interp)) + ")\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E";
}
pug_html = pug_html + "\u003Cbutton" + (" class=\"control print-selected\""+pug_attr("disabled", (selectedCount == 0), true, true)) + "\u003EPrint selected\u003C\u002Fbutton\u003E\u003Cbutton" + (" class=\"control mark-printed-selected\""+pug_attr("disabled", (selectedCount == 0), true, true)) + "\u003EMark as printed\u003C\u002Fbutton\u003E\u003Cbutton" + (" class=\"control card-selected no-mobile\""+pug_attr("disabled", (selectedCount == 0), true, true)) + "\u003ECards for selected\u003C\u002Fbutton\u003E\u003Cbutton" + (" class=\"control add-to-load-selected\""+pug_attr("disabled", (selectedCount == 0), true, true)) + "\u003EAdd to load\u003C\u002Fbutton\u003E\u003Cbutton" + (" class=\"control map-selected\""+pug_attr("disabled", (selectedCount == 0), true, true)) + "\u003EMap\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"refresh\"\u003E\u003Ci class=\"control sync clickable-no-color fa fa-refresh\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cdiv\u003E" + (null == (pug_interp = map) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"orders function-body\"\u003E";
if (orders.length == 0 && emptyOrderMessage) {
pug_html = pug_html + "\u003Cp\u003E" + (pug_escape(null == (pug_interp = emptyOrderMessage) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
}
if (orders.length > 1) {
pug_html = pug_html + "\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput" + (" class=\"orderSelect\""+" type=\"checkbox\" data-id=\"all\""+pug_attr("checked", allSelected, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"lineItems\"\u003E";
if (allSelected) {
pug_html = pug_html + ("Deselect all " + (pug_escape(null == (pug_interp = orders.length) ? "" : pug_interp)));
}
else {
pug_html = pug_html + ("Select all " + (pug_escape(null == (pug_interp = orders.length) ? "" : pug_interp)));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
// iterate orders
;(function(){
  var $$obj = orders;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var order = $$obj[pug_index4];
var isnew = ! order.deliveryDate
var notprinted = (order.orderHistory || []).filter((history) => history.newStatus == "Printed").length == 0;
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["order",{"no-delivery-date": ! order.deliveryDate, "not-printed": notprinted, "show-inventory": showInventory }], [false,true]), false, true)+pug_attr("data-orderid", order.id, true, true)) + "\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput" + (" class=\"orderSelect\""+" type=\"checkbox\""+pug_attr("data-id", order.id, true, true)+" name=\"order-#{order.id}\""+pug_attr("checked", selected[order.id], true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["dateCreated","orderClickable","clickable",{new: isnew}], [false,false,false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = renderCreatedDate(order.dateCreated)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["lineItems","orderClickable","clickable",{new: isnew}], [false,false,false,true]), false, true)) + "\u003E\u003Cdiv class=\"currentStatus\"\u003E";
if (order.important) {
pug_html = pug_html + "\u003Cspan class=\"important-order\"\u003E\u003Ci class=\"fa-solid fa-star\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + ("\u003Cspan\u003E" + (pug_escape(null == (pug_interp = "#" + order.number) ? "" : pug_interp)) + "\n\u003Cb\u003E" + (pug_escape(null == (pug_interp = order.currentStatus) ? "" : pug_interp)));
if (order.currentStatus == "Out for delivery" && getDriver(order)) {
pug_html = pug_html + "\n(" + (pug_escape(null == (pug_interp = getDriver(order)) ? "" : pug_interp)) + ")";
}
pug_html = pug_html + "\u003C\u002Fb\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var lineItem = $$obj[pug_index5];
pug_html = pug_html + "\u003Cdiv class=\"lineItem\"\u003E";
var name = renderName(lineItem)
var price = ! name || name.indexOf("$") == -1 ? renderDollars(lineItem.price) : "";
pug_html = pug_html + ("\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = name) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = price) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index5];
pug_html = pug_html + "\u003Cdiv class=\"lineItem\"\u003E";
var name = renderName(lineItem)
var price = ! name || name.indexOf("$") == -1 ? renderDollars(lineItem.price) : "";
pug_html = pug_html + ("\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = name) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = price) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo orderClickable clickable\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo && order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo && order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliveryNote\"\u003E" + (pug_escape(null == (pug_interp = renderDeliveryNote(order)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliveryDate\"\u003E";
if (order.deliveryDate) {
pug_html = pug_html + (pug_escape(null == (pug_interp = order.deliveryDate) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter) {
pug_html = pug_html + "\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n";
}
pug_html = pug_html + "\u003Ca class=\"date-suggestion clickable\"\u003EX\u003C\u002Fa\u003E\u003Ca class=\"set-clock\"\u003E\u003Ci class=\"fa-regular fa-clock\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca class=\"date-suggestion clickable\" data-suggestion=\"0\"\u003Etoday\u003C\u002Fa\u003E\n\u003Ca class=\"date-suggestion clickable\" data-suggestion=\"1\"\u003Etomorrow\u003C\u002Fa\u003E\n\u003Cinput class=\"datefield\" name=\"deliveryDate\" placeholder=\"Other date\" autocomplete=\"off\"\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (showInventory) {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["inventory",{"inventory-handled": order.inventoryHandled}], [false,true]), false, true)) + "\u003E";
if (order.inventoryHandled === false) {
var inventory = isDelivery(order) ? deliveryInventory : pickupInventory;
var totals = {};
for (const inv of inventory || []) totals[inv.name] = 0;
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var lineItem = $$obj[pug_index6];
// iterate lineItem.uses || []
;(function(){
  var $$obj = lineItem.uses || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var uses = $$obj[pug_index7];
totals[uses.name] += uses.quantity;
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var uses = $$obj[pug_index7];
totals[uses.name] += uses.quantity;
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index6];
// iterate lineItem.uses || []
;(function(){
  var $$obj = lineItem.uses || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var uses = $$obj[pug_index8];
totals[uses.name] += uses.quantity;
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var uses = $$obj[pug_index8];
totals[uses.name] += uses.quantity;
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003Cform\u003E\u003Ctable\u003E";
// iterate inventory || []
;(function(){
  var $$obj = inventory || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var inv = $$obj[pug_index9];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003Clabel\u003E" + (pug_escape(null == (pug_interp = inv.name) ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cinput" + (" class=\"number\""+pug_attr("name", inv.name, true, true)+" type=\"number\" size=\"3\""+pug_attr("value", totals[inv.name], true, true)) + "\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E(" + (pug_escape(null == (pug_interp = inv.quantity) ? "" : pug_interp)) + " available)\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var inv = $$obj[pug_index9];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003Clabel\u003E" + (pug_escape(null == (pug_interp = inv.name) ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cinput" + (" class=\"number\""+pug_attr("name", inv.name, true, true)+" type=\"number\" size=\"3\""+pug_attr("value", totals[inv.name], true, true)) + "\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E(" + (pug_escape(null == (pug_interp = inv.quantity) ? "" : pug_interp)) + " available)\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftable\u003E\u003Cbutton class=\"save-inventory\"\u003ESave\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E";
}
else {
var total = 0;
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index10 = 0, $$l = $$obj.length; pug_index10 < $$l; pug_index10++) {
        var lineItem = $$obj[pug_index10];
// iterate lineItem.uses || []
;(function(){
  var $$obj = lineItem.uses || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index11 = 0, $$l = $$obj.length; pug_index11 < $$l; pug_index11++) {
        var uses = $$obj[pug_index11];
if (uses.quantity > 0) {
total += uses.quantity;
pug_html = pug_html + "\u003Cdiv class=\"uses\"\u003E" + (pug_escape(null == (pug_interp = uses.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = uses.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index11 in $$obj) {
      $$l++;
      var uses = $$obj[pug_index11];
if (uses.quantity > 0) {
total += uses.quantity;
pug_html = pug_html + "\u003Cdiv class=\"uses\"\u003E" + (pug_escape(null == (pug_interp = uses.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = uses.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

if (total == 0) {
pug_html = pug_html + "\u003Cdiv class=\"uses clickable edit-inventory\"\u003ENo inventory use\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index10 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index10];
// iterate lineItem.uses || []
;(function(){
  var $$obj = lineItem.uses || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index12 = 0, $$l = $$obj.length; pug_index12 < $$l; pug_index12++) {
        var uses = $$obj[pug_index12];
if (uses.quantity > 0) {
total += uses.quantity;
pug_html = pug_html + "\u003Cdiv class=\"uses\"\u003E" + (pug_escape(null == (pug_interp = uses.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = uses.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index12 in $$obj) {
      $$l++;
      var uses = $$obj[pug_index12];
if (uses.quantity > 0) {
total += uses.quantity;
pug_html = pug_html + "\u003Cdiv class=\"uses\"\u003E" + (pug_escape(null == (pug_interp = uses.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = uses.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

if (total == 0) {
pug_html = pug_html + "\u003Cdiv class=\"uses clickable edit-inventory\"\u003ENo inventory use\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["edit-inventory",{"inventory-handled": order.inventoryHandled}], [false,true]), false, true)) + "\u003E\u003Cdiv\u003E\u003Ca class=\"clickable edit-inventory\"\u003EEdit inventory use\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var order = $$obj[pug_index4];
var isnew = ! order.deliveryDate
var notprinted = (order.orderHistory || []).filter((history) => history.newStatus == "Printed").length == 0;
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["order",{"no-delivery-date": ! order.deliveryDate, "not-printed": notprinted, "show-inventory": showInventory }], [false,true]), false, true)+pug_attr("data-orderid", order.id, true, true)) + "\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput" + (" class=\"orderSelect\""+" type=\"checkbox\""+pug_attr("data-id", order.id, true, true)+" name=\"order-#{order.id}\""+pug_attr("checked", selected[order.id], true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["dateCreated","orderClickable","clickable",{new: isnew}], [false,false,false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = renderCreatedDate(order.dateCreated)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["lineItems","orderClickable","clickable",{new: isnew}], [false,false,false,true]), false, true)) + "\u003E\u003Cdiv class=\"currentStatus\"\u003E";
if (order.important) {
pug_html = pug_html + "\u003Cspan class=\"important-order\"\u003E\u003Ci class=\"fa-solid fa-star\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + ("\u003Cspan\u003E" + (pug_escape(null == (pug_interp = "#" + order.number) ? "" : pug_interp)) + "\n\u003Cb\u003E" + (pug_escape(null == (pug_interp = order.currentStatus) ? "" : pug_interp)));
if (order.currentStatus == "Out for delivery" && getDriver(order)) {
pug_html = pug_html + "\n(" + (pug_escape(null == (pug_interp = getDriver(order)) ? "" : pug_interp)) + ")";
}
pug_html = pug_html + "\u003C\u002Fb\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index13 = 0, $$l = $$obj.length; pug_index13 < $$l; pug_index13++) {
        var lineItem = $$obj[pug_index13];
pug_html = pug_html + "\u003Cdiv class=\"lineItem\"\u003E";
var name = renderName(lineItem)
var price = ! name || name.indexOf("$") == -1 ? renderDollars(lineItem.price) : "";
pug_html = pug_html + ("\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = name) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = price) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index13 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index13];
pug_html = pug_html + "\u003Cdiv class=\"lineItem\"\u003E";
var name = renderName(lineItem)
var price = ! name || name.indexOf("$") == -1 ? renderDollars(lineItem.price) : "";
pug_html = pug_html + ("\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = name) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = price) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo orderClickable clickable\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo && order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo && order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliveryNote\"\u003E" + (pug_escape(null == (pug_interp = renderDeliveryNote(order)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliveryDate\"\u003E";
if (order.deliveryDate) {
pug_html = pug_html + (pug_escape(null == (pug_interp = order.deliveryDate) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter) {
pug_html = pug_html + "\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n";
}
pug_html = pug_html + "\u003Ca class=\"date-suggestion clickable\"\u003EX\u003C\u002Fa\u003E\u003Ca class=\"set-clock\"\u003E\u003Ci class=\"fa-regular fa-clock\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca class=\"date-suggestion clickable\" data-suggestion=\"0\"\u003Etoday\u003C\u002Fa\u003E\n\u003Ca class=\"date-suggestion clickable\" data-suggestion=\"1\"\u003Etomorrow\u003C\u002Fa\u003E\n\u003Cinput class=\"datefield\" name=\"deliveryDate\" placeholder=\"Other date\" autocomplete=\"off\"\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (showInventory) {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["inventory",{"inventory-handled": order.inventoryHandled}], [false,true]), false, true)) + "\u003E";
if (order.inventoryHandled === false) {
var inventory = isDelivery(order) ? deliveryInventory : pickupInventory;
var totals = {};
for (const inv of inventory || []) totals[inv.name] = 0;
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index14 = 0, $$l = $$obj.length; pug_index14 < $$l; pug_index14++) {
        var lineItem = $$obj[pug_index14];
// iterate lineItem.uses || []
;(function(){
  var $$obj = lineItem.uses || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index15 = 0, $$l = $$obj.length; pug_index15 < $$l; pug_index15++) {
        var uses = $$obj[pug_index15];
totals[uses.name] += uses.quantity;
      }
  } else {
    var $$l = 0;
    for (var pug_index15 in $$obj) {
      $$l++;
      var uses = $$obj[pug_index15];
totals[uses.name] += uses.quantity;
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index14 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index14];
// iterate lineItem.uses || []
;(function(){
  var $$obj = lineItem.uses || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index16 = 0, $$l = $$obj.length; pug_index16 < $$l; pug_index16++) {
        var uses = $$obj[pug_index16];
totals[uses.name] += uses.quantity;
      }
  } else {
    var $$l = 0;
    for (var pug_index16 in $$obj) {
      $$l++;
      var uses = $$obj[pug_index16];
totals[uses.name] += uses.quantity;
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003Cform\u003E\u003Ctable\u003E";
// iterate inventory || []
;(function(){
  var $$obj = inventory || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index17 = 0, $$l = $$obj.length; pug_index17 < $$l; pug_index17++) {
        var inv = $$obj[pug_index17];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003Clabel\u003E" + (pug_escape(null == (pug_interp = inv.name) ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cinput" + (" class=\"number\""+pug_attr("name", inv.name, true, true)+" type=\"number\" size=\"3\""+pug_attr("value", totals[inv.name], true, true)) + "\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E(" + (pug_escape(null == (pug_interp = inv.quantity) ? "" : pug_interp)) + " available)\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index17 in $$obj) {
      $$l++;
      var inv = $$obj[pug_index17];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003Clabel\u003E" + (pug_escape(null == (pug_interp = inv.name) ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cinput" + (" class=\"number\""+pug_attr("name", inv.name, true, true)+" type=\"number\" size=\"3\""+pug_attr("value", totals[inv.name], true, true)) + "\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E(" + (pug_escape(null == (pug_interp = inv.quantity) ? "" : pug_interp)) + " available)\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftable\u003E\u003Cbutton class=\"save-inventory\"\u003ESave\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E";
}
else {
var total = 0;
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index18 = 0, $$l = $$obj.length; pug_index18 < $$l; pug_index18++) {
        var lineItem = $$obj[pug_index18];
// iterate lineItem.uses || []
;(function(){
  var $$obj = lineItem.uses || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index19 = 0, $$l = $$obj.length; pug_index19 < $$l; pug_index19++) {
        var uses = $$obj[pug_index19];
if (uses.quantity > 0) {
total += uses.quantity;
pug_html = pug_html + "\u003Cdiv class=\"uses\"\u003E" + (pug_escape(null == (pug_interp = uses.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = uses.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index19 in $$obj) {
      $$l++;
      var uses = $$obj[pug_index19];
if (uses.quantity > 0) {
total += uses.quantity;
pug_html = pug_html + "\u003Cdiv class=\"uses\"\u003E" + (pug_escape(null == (pug_interp = uses.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = uses.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

if (total == 0) {
pug_html = pug_html + "\u003Cdiv class=\"uses clickable edit-inventory\"\u003ENo inventory use\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index18 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index18];
// iterate lineItem.uses || []
;(function(){
  var $$obj = lineItem.uses || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index20 = 0, $$l = $$obj.length; pug_index20 < $$l; pug_index20++) {
        var uses = $$obj[pug_index20];
if (uses.quantity > 0) {
total += uses.quantity;
pug_html = pug_html + "\u003Cdiv class=\"uses\"\u003E" + (pug_escape(null == (pug_interp = uses.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = uses.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index20 in $$obj) {
      $$l++;
      var uses = $$obj[pug_index20];
if (uses.quantity > 0) {
total += uses.quantity;
pug_html = pug_html + "\u003Cdiv class=\"uses\"\u003E" + (pug_escape(null == (pug_interp = uses.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = uses.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

if (total == 0) {
pug_html = pug_html + "\u003Cdiv class=\"uses clickable edit-inventory\"\u003ENo inventory use\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["edit-inventory",{"inventory-handled": order.inventoryHandled}], [false,true]), false, true)) + "\u003E\u003Cdiv\u003E\u003Ca class=\"clickable edit-inventory\"\u003EEdit inventory use\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"set-clock-modal js-modal\"\u003E\u003Cdiv class=\"title\"\u003ESet delivery time\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cform\u003E\u003Cdiv\u003E\u003Cdiv class=\"label\"\u003E\u003Clabel\u003EDeliver after\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"input\"\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"deliveryAfter\""+pug_attr("value", deliveryAfter, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv class=\"label\"\u003E\u003Clabel\u003EDelivery before\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"input\"\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"deliveryBefore\""+pug_attr("value", deliveryBefore, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buttons\"\u003E\u003Cbutton class=\"form-control save\"\u003ESave\u003C\u002Fbutton\u003E\u003Cbutton class=\"form-control js-modal-trigger\"\u003ECancel\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "Object" in locals_for_with ?
        locals_for_with.Object :
        typeof Object !== 'undefined' ? Object : undefined, "allSelected" in locals_for_with ?
        locals_for_with.allSelected :
        typeof allSelected !== 'undefined' ? allSelected : undefined, "delivery" in locals_for_with ?
        locals_for_with.delivery :
        typeof delivery !== 'undefined' ? delivery : undefined, "deliveryAfter" in locals_for_with ?
        locals_for_with.deliveryAfter :
        typeof deliveryAfter !== 'undefined' ? deliveryAfter : undefined, "deliveryBefore" in locals_for_with ?
        locals_for_with.deliveryBefore :
        typeof deliveryBefore !== 'undefined' ? deliveryBefore : undefined, "deliveryDateSince" in locals_for_with ?
        locals_for_with.deliveryDateSince :
        typeof deliveryDateSince !== 'undefined' ? deliveryDateSince : undefined, "deliveryInventory" in locals_for_with ?
        locals_for_with.deliveryInventory :
        typeof deliveryInventory !== 'undefined' ? deliveryInventory : undefined, "dueDate" in locals_for_with ?
        locals_for_with.dueDate :
        typeof dueDate !== 'undefined' ? dueDate : undefined, "emptyOrderMessage" in locals_for_with ?
        locals_for_with.emptyOrderMessage :
        typeof emptyOrderMessage !== 'undefined' ? emptyOrderMessage : undefined, "formatDate" in locals_for_with ?
        locals_for_with.formatDate :
        typeof formatDate !== 'undefined' ? formatDate : undefined, "getDriver" in locals_for_with ?
        locals_for_with.getDriver :
        typeof getDriver !== 'undefined' ? getDriver : undefined, "isDelivery" in locals_for_with ?
        locals_for_with.isDelivery :
        typeof isDelivery !== 'undefined' ? isDelivery : undefined, "map" in locals_for_with ?
        locals_for_with.map :
        typeof map !== 'undefined' ? map : undefined, "orders" in locals_for_with ?
        locals_for_with.orders :
        typeof orders !== 'undefined' ? orders : undefined, "pickupInventory" in locals_for_with ?
        locals_for_with.pickupInventory :
        typeof pickupInventory !== 'undefined' ? pickupInventory : undefined, "renderCreatedDate" in locals_for_with ?
        locals_for_with.renderCreatedDate :
        typeof renderCreatedDate !== 'undefined' ? renderCreatedDate : undefined, "renderDeliveryNote" in locals_for_with ?
        locals_for_with.renderDeliveryNote :
        typeof renderDeliveryNote !== 'undefined' ? renderDeliveryNote : undefined, "renderDollars" in locals_for_with ?
        locals_for_with.renderDollars :
        typeof renderDollars !== 'undefined' ? renderDollars : undefined, "renderName" in locals_for_with ?
        locals_for_with.renderName :
        typeof renderName !== 'undefined' ? renderName : undefined, "search" in locals_for_with ?
        locals_for_with.search :
        typeof search !== 'undefined' ? search : undefined, "selected" in locals_for_with ?
        locals_for_with.selected :
        typeof selected !== 'undefined' ? selected : undefined, "selectedCount" in locals_for_with ?
        locals_for_with.selectedCount :
        typeof selectedCount !== 'undefined' ? selectedCount : undefined, "showFilters" in locals_for_with ?
        locals_for_with.showFilters :
        typeof showFilters !== 'undefined' ? showFilters : undefined, "showInventory" in locals_for_with ?
        locals_for_with.showInventory :
        typeof showInventory !== 'undefined' ? showInventory : undefined, "state" in locals_for_with ?
        locals_for_with.state :
        typeof state !== 'undefined' ? state : undefined, "states" in locals_for_with ?
        locals_for_with.states :
        typeof states !== 'undefined' ? states : undefined, "today" in locals_for_with ?
        locals_for_with.today :
        typeof today !== 'undefined' ? today : undefined));
    ;;return pug_html;}